import type { EntityAdapter } from '@reduxjs/toolkit';
import type {
  IMessage,
  INormalizedMessagesOfThreadResponse,
} from '@ui/components/organisms/message/message.typings';

type PinnableThreadCache = Pick<
  INormalizedMessagesOfThreadResponse,
  'messages' | 'pinnedMessages' | 'messageOrder'
>;

export const COMMENT_PIN_FORBIDDEN_MESSAGE = 'Only moderators and crew admins can pin comments.';
export const COMMENT_PIN_FAILED_MESSAGE = "Couldn't update the pin. Try again.";

export const commentPinErrorMessage = (error: unknown) =>
  (error as { status?: unknown } | undefined)?.status === 403
    ? COMMENT_PIN_FORBIDDEN_MESSAGE
    : COMMENT_PIN_FAILED_MESSAGE;

export const applyMessagePin = (
  cache: PinnableThreadCache,
  adapter: EntityAdapter<IMessage, string>,
  messageId: string,
  pin: boolean,
  pinnedAt: string = new Date().toISOString(),
) => {
  const listedMessage = cache.messages.entities[messageId];
  const pinnedMessage = cache.pinnedMessages?.find((message) => message.id === messageId);
  const otherPinnedMessages = (cache.pinnedMessages ?? []).filter(
    (message) => message.id !== messageId,
  );

  if (pin) {
    const message = listedMessage ?? pinnedMessage;
    if (!message) return;

    if (listedMessage) adapter.removeOne(cache.messages, messageId);
    if (cache.messageOrder) {
      cache.messageOrder = cache.messageOrder.filter((id) => id !== messageId);
    }
    cache.pinnedMessages = [{ ...message, pinned_at: pinnedAt }, ...otherPinnedMessages];
    return;
  }

  if (!pinnedMessage) return;

  cache.pinnedMessages = otherPinnedMessages;
  adapter.upsertOne(cache.messages, { ...pinnedMessage, pinned_at: null });
  if (cache.messageOrder) {
    cache.messageOrder = [messageId, ...cache.messageOrder.filter((id) => id !== messageId)];
  }
};
